import React, { useEffect, useState } from 'react';
import { toast } from 'react-toastify';

import { Spinner } from 'reactstrap';
import { Container } from '~/styles/pagesStyle';

import api from '~/services/api';

import Menu from '~/components/Menu';
import Card from './Card';
import Footer from '~/components/Footer';

function SubMenuLista() {
  const [loading, setLoading] = useState(false);
  const [moduloSelected, setModuloSelected] = useState(false);
  const [menuSelected, setMenuSelected] = useState(false);
  const [modulos, setModulos] = useState([{}]);
  const [menus, setMenus] = useState([{}]);

  useEffect(() => {
    setLoading(true);
    async function getModulesData() {
      await api
        .get('/Modulo/GetPaginado/Page/1/Length/100')
        .then((response) => {
          setModulos(response.data.registros);
          setLoading(false);
        })
        .catch(() => {
          toast.error('Erro ao buscar dados dos módulos, recarregue a página');
          setLoading(false);
        });
    }
    getModulesData();
  }, []);

  return (
    <Container>
      <Footer />
      <Menu />
      {Object.keys(modulos).length === 0 ? (
        <Spinner
          style={{ width: '3rem', height: '3rem', margin: '5% 450px' }}
        />
      ) : (
        <Card
          loading={loading}
          moduloSelected={moduloSelected}
          modulos={modulos}
          menus={menus}
          menuSelected={menuSelected}
          setModuloSelected={setModuloSelected}
          setMenuSelected={setMenuSelected}
          setMenus={setMenus}
          setLoading={setLoading}
        />
      )}
    </Container>
  );
}

export default SubMenuLista;
